import { observer } from 'mobx-react-lite';
import React, { useContext, useState } from 'react';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { UiContext } from 'shared/lib/contexts/uiContext';
import ActionInlineButton from 'shared/lib/components/controls/buttons/actionInlineButton';
import PageInnerContainer from 'pages/components/pageInnerContainer';
import EditSectionModalController from 'widgets/sections/editSectionModalController';
import CreateFolderModalController from 'widgets/folders/createFolderModalController';
import { SectionModel } from 'entities/section/model/sectionModel';
import { useTranslation } from 'react-i18next';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import ExplorerHeader from 'pages/explorerPage/explorerHeader';
import { useNavigate } from 'react-router-dom';
import { useSearchParamsUtils } from 'app/hooks/useSearchParamsUtils';
import IconCirclePlus from 'shared/icons/iconCirclePlus';
import SearchFallback from 'pages/searchFallback';
import ContentGridController from 'widgets/grids/contentGridController';

export default observer(function ExplorerSection({
  sectionModel,
}: {
  sectionModel: SectionModel;
}) {
  const { t } = useTranslation();
  const {
    mobxStore,
    mobxStore: {
      authStore: { user },
    },
  } = useContext(MobxContext);
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const navigate = useNavigate();

  const { isLessLaptop } = useBooleanScreens();

  const [isEditSection, setIsEditSection] = useState(false);
  const [isCreateFolder, setIsCreateFolder] = useState(false);

  // Временный(конечно же нет) костыль
  // TODO: Починить unsorted
  const unsortedFolderId = 'TODO';
  const isOnlyView = mobxStore.authStore.user?.isOnlyView;
  const isAdmin = mobxStore.authStore.user?.isAdmin;

  const { getSectionSearchParams } = useSearchParamsUtils();

  // const filesHelper = new FilesAndTablesHelper({
  //   files: sectionModel.files,
  //   tables: sectionModel.tables,
  //   sort: SortingValue.UPDATING_DEC,
  // });

  return sectionModel?.data ? (
    <SearchFallback>
      <PageInnerContainer>
        <ExplorerHeader
          name={sectionModel.data.name}
          isButtonsDisabled={user?.isOnlyView || isLessLaptop}
          onSettings={isAdmin ? () => setIsEditSection(true) : undefined}
          onGoToUpload={() => {
            navigate({
              pathname: '/upload/',
              search: getSectionSearchParams({
                sectionId: sectionModel.id,
              }),
            });
          }}
        ></ExplorerHeader>

        {isOnlyView || isLessLaptop ? null : (
          <ActionInlineButton
            Icon={IconCirclePlus}
            onClick={() => setIsCreateFolder(true)}
          >
            {t('noCategory.createNewFolder')}
          </ActionInlineButton>
        )}

        <ContentGridController
          items={sectionModel.content}
          sort={{ key: sectionModel.sortKey, order: sectionModel.sortOrder }}
          onSortChange={(val) => {
            sectionModel.sortKey = val.key;
            sectionModel.sortOrder = val.order;
            sectionModel.getContent({ in_trash: null });
          }}
          afterFolderMerge={() => {
            sectionModel.getContent({ in_trash: null });
          }}
          afterFolderUpdate={() => {
            sectionModel.getContent({ in_trash: null });
          }}
          afterFolderDelete={(id) => {
            sectionModel.localDeleteFolders([id]);
          }}
          afterFileDelete={(id) => sectionModel.localDeleteFile(id)}
          afterFileUpdate={async () => {
            await sectionModel.getContent({ in_trash: null });
          }}
          afterTableDelete={(id) => sectionModel.localDeleteTable(id)}
          afterTableUpdate={async () => {
            await sectionModel.getContent({ in_trash: null });
          }}
          afterFolderCreate={() => {
            sectionModel.getContent({ in_trash: null });
          }}
        ></ContentGridController>
      </PageInnerContainer>

      {isEditSection && (
        <EditSectionModalController
          sectionModel={sectionModel}
          handleClose={() => setIsEditSection(false)}
          afterSectionDelete={(sectionModel) => {
            mobxStore.sectionStore.localDeleteSections([sectionModel.id]);
            navigate({
              pathname: '/',
            });
          }}
        ></EditSectionModalController>
      )}

      {isCreateFolder && (
        <CreateFolderModalController
          isOpen={true}
          handleClose={() => setIsCreateFolder(false)}
          sectionId={sectionModel.id}
          afterFolderCreate={(newFolderModel) => {
            sectionModel.localAddFolder(newFolderModel);
          }}
        ></CreateFolderModalController>
      )}
    </SearchFallback>
  ) : (
    <></>
  );
});
